import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Validators } from '@angular/forms';
import { UntypedFormGroup, ValidationErrors } from '@angular/forms';
import { Signup, Employer } from '@app/_models';
import { State } from '@app/_models/signups/geography';
import { SignupService } from '@app/_services';
import { FadvAlternateAlertComponent, FadvDatePickerComponent } from '@fa-switch-sharedservices/ng-elements';
import { Subscription } from 'rxjs';


@Component({
  selector: 'app-employment',
  templateUrl: './employment.component.html',
  styleUrls: ['./employment.component.less']
})
export class EmploymentComponent implements OnInit {

  @Input() formGroup: UntypedFormGroup;
  @Input() previousEmployers: Employer[];
  @Input() loading: boolean;
  @Input() states: State[];
  @Input() employmentFormInvalid: boolean;
  @Output() onRemove: EventEmitter<string> = new EventEmitter();
  @Output() onSubmit: EventEmitter<string> = new EventEmitter();
  @Output() onCancel: EventEmitter<boolean> = new EventEmitter();
  @Output() disableValidators: EventEmitter<boolean> = new EventEmitter();
  @Output() enableValidators: EventEmitter<boolean> = new EventEmitter();
  @Output() endDateValidator: EventEmitter<boolean> = new EventEmitter();
  @ViewChild('fadvDatePickerStartDate') datePickerStartDate: FadvDatePickerComponent;
  @ViewChild('fadvDatePickerEndDate') datePickerEndDate: FadvDatePickerComponent;
  @ViewChild('employmentAlert') employmentAlert: FadvAlternateAlertComponent;
  disabled: boolean;
  employerExists = false;
  subscription: Subscription;
  stateInvalid = false;
  cityInvalid = false;
  startDateInvalid = false;
  endDateInvalid = false;
  positionInvalid
  employerNameInvalid = false;
  employmentInvalid = false;
  today = new Date();
  isCurrentEmployer = false;
  phoneInvalid = false;
  disableEmploymentButton = false;
  employerDataIsBad: boolean;
  current: boolean;

  constructor() { }

  ngOnInit(): void {
    // this.subscription = this.formGroup.valueChanges.subscribe(x => {
    //   if(this.formGroup.invalid)
    //   {
    //     this.employmentFormInvalid = true;
    //   }
    //   else
    //   {
    //     this.employmentFormInvalid = false;
    //   }
    // })
  }

  ngOnDestroy() {
    // this.subscription.unsubscribe();
  }

  // removePreviousEmployer(employer: string) {
  //   this.onRemove.emit(employer);
  // }

  // addEmployer() {
  //   this.employerDataIsBad = false;
  //   var inputEmployer = new Employer();

  // inputEmployer = this.formGroup.value;

  // if(inputEmployer.isCurrentEmployer == null){
  //   inputEmployer.isCurrentEmployer = false;
  // }

  //   Object.values(inputEmployer).forEach(x => {
  //     if (x === '' || x === null){
  //       this.employerDataIsBad = true;
  //       if(this.employerDataIsBad){
  //         this.employmentAlert.show();
  //         return;
  //       }
  //     }
  //   })

  //   if(!this.employerDataIsBad){
  //     this.datePickerStartDate.value = undefined;
  //     this.datePickerEndDate.value = undefined;
  //     // this.disableEmploymentButton = true;
  //     this.onSubmit.emit();

  //     this.previousEmployers;
  //   }
  // }

  // handleSetValidatorsAfterSubmit(){
  //   if (this.previousEmployers.length != 0 && this.disableEmploymentButton == true){
  //     this.enableValidators.emit(true);

  //     if(this.formGroup.invalid){
  //       this.disableEmploymentButton = false;
  //     }
  //   }

    
    // if(this.formGroup.touched){
    //   if(this.formGroup.invalid)
    //   {
    //     this.employmentFormInvalid = true;
    //   }
    //   else
    //   {
    //     this.employmentFormInvalid = false;
    //   }
    // }
  // }

  checkedCurrentEmployer(event: any)
  {
    this.isCurrentEmployer = event
    this.current = event;
    this.endDateValidator.emit(event)
  }

  handleStartDate(event: any)
  {
    this.formGroup.controls.startDate.setValue(event.target.value);
  }

  handleEndDate(event: any)
  {
    this.formGroup.controls.endDate.setValue(event.target.value);
  }

  // cancel(){
  //   this.datePickerStartDate.value = null;
  //   this.datePickerEndDate.value = null;
  //   this.disableEmploymentButton = true;
  //   this.onCancel.emit(true);
  // }

  showValidation(field: string){
    if(this.formGroup.controls[field].invalid){
        this[field+"Invalid"] = true;
    }
    else{
        this[field+"Invalid"] = false;
    }
}

}
